<template>
  <section class="hc-card" :class="{ 'hc-card--interactive': interactive }">
    <header v-if="$slots.header || title || $slots.actions" class="hc-card__header">
      <slot name="header">
        <div>
          <h3 class="mb-1 font-weight-bolder">{{ title }}</h3>
          <p v-if="subtitle" class="mb-0 text-muted">{{ subtitle }}</p>
        </div>
      </slot>
      <slot name="actions" />
    </header>
    <div class="hc-card__body"><slot /></div>
    <footer v-if="$slots.footer" class="hc-card__footer"><slot name="footer" /></footer>
  </section>
</template>

<script>
export default {
  name: "HcCard",
  props: {
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
    interactive: { type: Boolean, default: false },
  },
};
</script>
